<template>
  <div>
    <h1>Manage Application Settings</h1>

    <div>
      <b-card no-body>
        <b-tabs pills card vertical nav-wrapper-class="w-25">
          <b-tab title="Email Settings" active>
            <b-card-text></b-card-text>
          </b-tab>
          <b-tab title="Welcome Page">
            <b-card-text></b-card-text>
          </b-tab>
          <b-tab title="ICS Settings">
            <b-card-text></b-card-text>
          </b-tab>
          <b-tab title="Leave Request Settings">
            <b-card-text></b-card-text>
          </b-tab>
        </b-tabs>

      </b-card>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'
  

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    mixins: [validationMixin],
    components: {
      
    },
    data: () => ({
      selectedStatus: '',
      newItem: '',
      checklist: {},
    }),

     validations: {
        selectedStatus: { required  },
     },

    watch: {
      selectedStatus() {
       
      }
    },

    created () {
    },

    methods: {
      
    }
  }
</script>